// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__lJ12r","submitButton":"LoginForm_submitButton__u0HA8","centered":"LoginForm_centered__Ph5Jm"};